import { useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import useMediaQuery from "@mui/material/useMediaQuery";
import InputLabel from "@mui/material/InputLabel";
import Pagination from "@mui/material/Pagination";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import TextField from "@mui/material/TextField";
import { Typography } from "@mui/material";
import {
  editWordGroupNameApi,
  removeWordGroup,
} from "../../../../../services/userSaveWordApi";
import { ToastContainer, toast } from "react-toastify";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../utils/utilsFunctions";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(name, data, id) {
  return { name, data, id };
}

// دیتاهای مورد نیاز و اسم نمایشی آنها را تین میکند
const neededData = {
  nameOfgroup: "نام گروه",
};

export default function ListOfGroups(props) {
  const { setNumberPageAndPerPage, pageAndPerPage, fetchedGroupOfWords } =
    props;
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);
  const [deleteGroupId, setDeleteGroupId] = useState("");
  const [newName, setNewName] = useState("");
  const [openEditBox, setOpenEditBox] = useState(false);
  const [editGroupId, OpenEditGroupId] = useState({
    id: "",
    oldName: "",
  });

  // const RecivedData = b["docs"];
  const RecivedData = fetchedGroupOfWords;
  // هر مجموعه از دیتا را برای هر جدول درون یک المنت آرایه میریزد
  let listOfTable = RecivedData.map((el, index) => {
    const rowOfTableData = [];
    for (const property in el) {
      if (neededData[property]) {
        if (
          property == "buyingDate" ||
          property == "endingDate" ||
          property == "startingDate"
        ) {
          const date = new DateObject({
            date: el[property],
            calendar: persian,
            locale: persian_fa,
          });
          rowOfTableData.push(
            createData(neededData[property], date.format(), el._id)
          );
        } else
          rowOfTableData.push(
            createData(neededData[property], el[property], el._id)
          );
      }
    }
    return rowOfTableData;
  });

  const handleDeleteAndEditGroup = async (type, data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      let res;
      if (type == "delete") {
        res = await removeWordGroup(data)
      } else if (type == "edit") {
        res = await editWordGroupNameApi(data)
      }
      const resData = checkResponseData(res);
      if (
        res["data"] &&
        res["data"]["data"] &&
        res["data"]["data"]["data"] &&
        res["data"]["data"]["data"][0]
      ) {
        toast.update(toastMsg, { render: res["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });

        if (!res["data"]["data"]["data"][0]["_id"])
          customToastify(
            "error",
            "گروهی با این مشخصات وجود ندارد،لطفا صفحه را بروز کنید",
            5000
          );
      } else {
        toast.update(toastMsg, { render: res["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      console.error(error);
    }
  };

  const handleClickOpenDeleteAlert = (action, id) => {
    if (action == "delete") setDeleteGroupId(id);
    else if (action == "doneDelete")
      handleDeleteAndEditGroup("delete", { groupId: deleteGroupId });
    else if (action == "cancelDelete") setDeleteGroupId("");
    setOpenDeleteAlert(!openDeleteAlert);
  };

  const handleClickOpenEditBox = (action, id, oldName) => {
    if (action == "edit") OpenEditGroupId({ id, oldName });
    else if (action == "cancelEdit") setNewName("");
    else if (action == "doneEdit")
      handleDeleteAndEditGroup("edit", {
        groupId: editGroupId.id,
        nameOfgroup: newName,
      });
    setOpenEditBox(!openEditBox);
  };

  const showRowData = (index, name, data) => {
    return <StyledTableCell align="left">{data}</StyledTableCell>;
  };

  return (
    <>
      <Dialog
        open={openDeleteAlert}
        onClose={handleClickOpenDeleteAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          sx={{ backgroundColor: "red", mb: 2, py: 0 }}
          id="alert-dialog-title"
        >
          {"حذف گروه"}
        </DialogTitle>
        <DialogContent>
          <Typography id="alert-dialog-description">
            آیا از حذف این گروه مطمین هستید
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClickOpenDeleteAlert("cancelDelete");
            }}
            color="primary"
            variant="outlined"
            autoFocus
          >
            لغو
          </Button>
          <Button
            onClick={() => {
              handleClickOpenDeleteAlert("doneDelete");
            }}
            variant="outlined"
          >
            بله
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openEditBox}
        onClose={handleClickOpenEditBox}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          sx={{ backgroundColor: "#ed6c02", mb: 2, py: 0 }}
          id="alert-dialog-title"
        >
          {"ویرایش نام گروه"}
        </DialogTitle>
        <DialogContent>
          <TextField
            sx={{ mt: 1 }}
            id="editGroupName"
            label="نام جدید گروه"
            variant="outlined"
            defaultValue={editGroupId.oldName}
            onChange={(e) => {
              setNewName(e.target.value);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClickOpenEditBox("cancelEdit");
            }}
            variant="outlined"
            autoFocus
          >
            لغو
          </Button>
          <Button
            onClick={() => {
              handleClickOpenEditBox("doneEdit");
            }}
            variant="outlined"
          >
            بله
          </Button>
        </DialogActions>
      </Dialog>

      <Box>
        {listOfTable.map((oneRow, index) => (
          <TableContainer
            key={`ListOfGroups-${index}`}
            component={Paper}
            sx={{ mb: 1 }}
          >
            <Table sx={{ minWidth: 10 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "20%" : "35%" }}
                  ></StyledTableCell>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "60%" : "35%" }}
                    align="left"
                  ></StyledTableCell>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "20%" : "30%" }}
                    align="left"
                  ></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {oneRow.map((row, indexRow) => (
                  <StyledTableRow key={`${row.name}-${indexRow}`}>
                    <StyledTableCell component="th" scope="row">
                      {row.name}
                    </StyledTableCell>
                    {showRowData(index, row.name, row.data)}
                    <StyledTableCell component="th" scope="row">
                      <IconButton
                        aria-label="edit"
                        color="warning"
                        onClick={(e) => {
                          handleClickOpenEditBox("edit", row.id, row.data);
                        }}
                      >
                        <ModeEditIcon />
                      </IconButton>
                      <IconButton
                        aria-label="delete"
                        color="error"
                        onClick={(e) => {
                          handleClickOpenDeleteAlert("delete", row.id);
                        }}
                      >
                        <DeleteForeverIcon />
                      </IconButton>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ))}
        <Box sx={{ display: "flex", alignItems: "baseline" }}>
          <Pagination
            count={pageAndPerPage.totalPages}
            siblingCount={0}
            color="primary"
            hideNextButton={pageAndPerPage.hasNextPage}
            hidePrevButton={pageAndPerPage.hasPrevPage}
            onChange={(e, value) => {
              setNumberPageAndPerPage("page", value);
            }}
          />
          {pageAndPerPage.totalPages == 0 ? null : (
            <>
              تعداد کل:{pageAndPerPage.totalDocs}
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-select-small">تعداد در هر صفحه</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  defaultValue={5}
                  value={pageAndPerPage.perPage}
                  label="تعداد در هر صفحه"
                  onChange={(e) => {
                    setNumberPageAndPerPage("perPage", e.target.value);
                  }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={35}>35</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
            </>
          )}
        </Box>
      </Box>
    </>
  );
}
